type Color = string;

export type StatusColorSchema = {
  [statusValue: string]: Color;
};

export const USAGE_HEADER_STATUS_COLORS: StatusColorSchema = {
  SalesOrdersGeneration: '#efa611',
  Imported: '#40820b',
  SalesOrdersGenerated: '#40828b',
  Matched: '#40826b',
  PartiallyProcessed: '#036d83',
  ImportError: '#d82c0d',
  MatchingError: '#c33f3b',
  SalesOrdersGenerationError: '#e5173f',
  Draft: '#73808b',
  Abandoned: '#73808b',
  Archived: '#4f5a65',
  Matching: '#e8ad44'
};